import { render, staticRenderFns } from "./weeklyMeetingList.vue?vue&type=template&id=2fd38551&scoped=true"
import script from "./weeklyMeetingList.vue?vue&type=script&lang=js"
export * from "./weeklyMeetingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd38551",
  null
  
)

export default component.exports